<template>
  <div class="d-flex flex-column pb-3" style="gap: 1em">
    <fccCidadesDeProvasRelacionadasAConfiguracao @importado="atualizarCidadesNaTela" />
    <template v-if="cidadesImportadas.length > 0">
      <fccCidadesDeProvasImportadas
        :cidades-importadas="cidadesImportadas"
        @cidade-excluida="atualizarCidadesNaTela" />
      <fccTratamentoColegios :cidades-de-prova="cidadesDeProva" />
      <fccTratamentoCandidatos :cidades-de-prova="cidadesDeProva"
    /></template>

    <fccLocalDeProvaStatus :etapa="etapa" />
  </div>
</template>
<script>
import fccCidadesDeProvasRelacionadasAConfiguracao from './fccCidadesDeProvasRelacionadasAConfiguracao/fccCidadesDeProvasRelacionadasAConfiguracao.vue'
import fccCidadesDeProvasImportadas from './fccCidadesDeProvasImportadas/fccCidadesDeProvasImportadas.vue'
import fccTratamentoColegios from './fccTratamentoColegios/fccTratamentosColegios.vue'
import fccTratamentoCandidatos from './fccTratamentoCandidatos/fccTratamentoCandidatos.vue'
import store from '../../../../store'
import axios from 'axios'
import fccLocalDeProvaStatus from '../fccLocalDeProvaStatus.vue'
import { TP_ETAPA } from '../constantes'

export default {
  components: {
    fccCidadesDeProvasRelacionadasAConfiguracao,
    fccCidadesDeProvasImportadas,
    fccTratamentoColegios,
    fccTratamentoCandidatos,
    fccLocalDeProvaStatus
  },
  data() {
    return {
      cidadesImportadas: [],
      cidadesDeProva: []
    }
  },
  computed: {
    configuracao() {
      return store.state.localDeProva.configuracao
    },
    etapa() {
      return TP_ETAPA.LOCAL_DE_PROVA
    }
  },
  watch: {
    configuracao() {
      this.atualizarCidadesNaTela()
    }
  },
  created() {
    this.atualizarCidadesNaTela()
  },
  methods: {
    atualizarCidadesNaTela() {
      this.getCidadesImportadas()
      this.listarCidadesDeProva()
    },
    leftPad(number, width, pad = '0') {
      return number.toString().padStart(width, pad)
    },
    getCidadesImportadas() {
      axios
        .get(
          store.state.baseUrlLocalDeProva +
            `LocalExameCidade/GetCidadesImportadas/${this.configuracao.idlocalconfig}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.cidadesImportadas = response.data
        })
        .catch(this.setErrorSystem)
    },
    listarCidadesDeProva() {
      axios
        .get(
          store.state.baseUrlLocalDeProva +
            `Colegio/ListarCidadesTratamentoColegios/${this.configuracao.idlocalconfig}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.cidadesDeProva = response.data.map((item) => {
            return {
              ...item,
              cidadeprova: this.leftPad(item.codcidexame, 3) + ' - ' + item.cidadeprova
            }
          })
        })
        .catch(this.setErrorSystem)
    }
  }
}
</script>